import { iTest } from "@/services";

const state = {
  testList: [],
  totalCount: null,
};

const mutations = {};

const actions = {
  /** test 테이블 데이터 조회 */
  async getTestList(
    { state },
    payload = {
      projectId: null,
      taskId: null,
      options: null,
    }
  ) {
    const options = payload.options || {
      keyword: "",
      page: 1,
      limit: 10,
      order: "ASC",
      sort: "startDate",
    };

    const newPayload = {
      testStatuses: ["E", "T", "P", "F"],
      ...options,
      ...(payload.projectId && { projectId: payload.projectId }),
      ...(payload.taskId && { taskId: payload.taskId }),
    };

    const { data } = await iTest.getTestList(newPayload);
    if (data?.code) {
      console.error(data?.code);
      return;
    }

    state.testList = data?.payload.testListItems;
    state.totalCount = data?.payload.totalCount;
    return data?.payload; // { totalCount, testListItems }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
